<template>
        <div class="bg-wrap">
            <div class="kv">
            </div>
             <div class="content-wrap">
                    <span class="title">{{title}}</span>
                    <span class="a">必答题</span>
                    <div class="b shadow" v-if="state==0">
                        <label >等开题</label>
                    </div>
                    <div class="b shadow" v-if="state==2">
                      <label >题目已抢完</label>
                    </div>
                    <div class="b light" @click="toAnswer" v-if="state==1">
                        <label >随机抽题</label>
                    </div>
                    <span class="c">{{hint}}</span>
             </div>
        </div>
</template>

<script>
    import {getAnswer,valuableQuestion} from "../../assets/js/api";

    export default {
        data(){
            return{
                title:"共话新知",
                hint:"（每题1分，共10道题目，答题时间5分钟）",
                type: this.$route.query.type,
                state:-1
            }
        },
        mounted(){
            this.initWebSocket();
            this.getValuableCompQuestion(this.type)
        },
        methods:{
            toAnswer(){
                this.getSomeAnswer(this.$store.state.playerId,this.type)
            },
            async getSomeAnswer(playerId,type){
                let res = await getAnswer({playerId,type})
                console.log(res,"a===")
                if(res.data.success==true){
                    this.$router.replace({path:"playerRegAnswer",query:{type:this.type}})
                    this.$toast("请在倒计时结束前提交")
                }else{
                    this.$toast(res.data.message)
                }
            },
            async getValuableCompQuestion(type){
                const res = await valuableQuestion({type})
                if(res.data.success){
                    this.state = res.data.data.state
                }
            },
            initWebSocket: function () {
                console.log("---socket 初始化---")
                this.websock = new WebSocket("ws://server.iumed.com.cn/plus/one/websocket");
                // this.websock = new WebSocket("ws://192.168.31.230:9090/one/websocket");
                this.websock.onopen = this.websocketonopen;
                this.websock.onerror = this.websocketonerror;
                this.websock.onmessage = this.websocketonmessage;
                this.websock.onclose = this.websocketclose;
            },
            websocketonopen: function () {
                console.log("WebSocket连接成功");
            },
            websocketonerror: function (e) {
                console.log("WebSocket连接发生错误"+e.code);
            },
            websocketonmessage: function (e) {
                console.log("----signal coming----",e)
                this.getValuableCompQuestion(this.type)
            },
            websocketclose: function (e) {
                console.log("connection closed (" + e.code + ")");
            },
        }

    }
</script>

<style scoped lang="scss">
    .bg-wrap{
        width: 100%;
        /*max-width: 375px;*/
        height: 100vh;
        background: #FFF url("../../assets/img/answer_bg.png") no-repeat;
        background-size: 100% 100%;
        margin: 0 auto;
    }
    .kv{
        width: 100%;
        height: 250px;
        background: #FFF url("../../assets/img/answer_kv.png") no-repeat;
        background-size: 100% 100%;
        margin: 0 auto;
        position: relative;
    }
    .content-wrap{
        display: flex;
        flex-flow: column;
        align-items: center;
    }
    .content-wrap .title{
        color: #FFF;
        font-size: 38px;
        font-weight: bold;
        font-style: italic;
        letter-spacing: 3px;
    }

    .a{
        color: #FFF;
        font-size: 25px;
        margin-top: 20px;
        opacity: 0.8;
    }
    .b{
        color: #000;
        margin-top: 30px;
        font-size: 14px;
        width: 85%;
        height: 32px;
        line-height: 32px;
        text-align: center;
        border-radius: 15px;
    }
    .c{
        margin-top: 10px;
        color: #FFF;
        font-size: 15px;
        opacity: 0.8;
    }

    .shadow{
        background: #999;
    }

    .light{
        background: #ffdb36;
    }



</style>